import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { ArrowLeft, LockKeyhole } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "@/components/ui/sonner";
import { RestaurantBrand } from "@/components/RestaurantBrand";
import CreditFooter from "@/components/CreditFooter";
import api from "@/lib/api";
import usePageTitle from "@/lib/usePageTitle";

export default function AdminLogin() {
  usePageTitle("Accesso amministratore");
  const navigate = useNavigate();
  const [email, setEmail] = useState("admin@novezerodue.it");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const submit = async (event) => {
    event.preventDefault(); setError(""); setLoading(true);
    try {
      const { data } = await api.post("/auth/admin/login", { email, password });
      localStorage.setItem("nz_admin_token", data.access_token);
      toast.success("Accesso effettuato");
      navigate("/admin/menu");
    } catch (e) { setError(e.response?.status === 401 ? "Email o password non corrette." : "Accesso non riuscito. Controlla la connessione e riprova."); }
    finally { setLoading(false); }
  };
  return <div className="admin-login-page" data-testid="admin-login-page"><div className="admin-login-card">
    <RestaurantBrand testId="login-logo" />
    <div><h1 data-testid="admin-login-title">Il tuo menu, sempre aggiornato.</h1><p className="mt-2" data-testid="admin-login-subtitle">Accedi per gestire le proposte del ristorante.</p></div>
    <form onSubmit={submit}>
      <div className="admin-field"><Label htmlFor="admin-email">Email</Label><Input id="admin-email" type="email" autoComplete="username" value={email} onChange={e => setEmail(e.target.value)} required data-testid="admin-email" /></div>
      <div className="admin-field"><Label htmlFor="admin-password">Password</Label><Input id="admin-password" type="password" autoComplete="current-password" value={password} onChange={e => setPassword(e.target.value)} required aria-invalid={Boolean(error)} data-testid="admin-password" /></div>
      {error && <p role="alert" className="admin-error" data-testid="admin-login-error">{error}</p>}
      <Button disabled={loading} type="submit" data-testid="admin-login-submit"><LockKeyhole />{loading ? "Accesso in corso…" : "Accedi"}</Button>
    </form>
    <Button asChild variant="link" className="justify-start p-0" data-testid="login-back-to-menu"><Link to="/menu"><ArrowLeft /> Torna al menu</Link></Button>
  </div><CreditFooter className="restaurant-credit" /></div>;
}
